var React = require('react');

function Teaser (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 16.3155V7.68454C8 6.92548 8.81248 6.44317 9.47885 6.80665L17.3905 11.1221C18.0854 11.5011 18.0854 12.4989 17.3905 12.8779L9.47885 17.1934C8.81248 17.5568 8 17.0745 8 16.3155Z","fill":"currentColor"}));
}

Teaser.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Teaser;

Teaser.default = Teaser;
